import { render } from "./XIconSolidTarget.vue?vue&type=template&id=b29ad71c"
import script from "./XIconSolidTarget.vue?vue&type=script&lang=js"
export * from "./XIconSolidTarget.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/pointra/manager/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"XIconSolidTarget.vue"]])

export default __exports__